import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Path } from '../constants';

/** Use the same centralized decision as the navigation, before loading a page. */
export const estimationConfigurationGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  return auth.canManageEstimationConfiguration()
    ? true
    : inject(Router).createUrlTree([`/${Path.DASHBOARD}`]);
};
